import NoImage from 'components/etc/NoImage';
import React, { useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IProject, ISupportLanguage } from 'utils/types/storyTypes';

interface IProps {
  data: IProject | undefined;
  lang: ISupportLanguage | undefined;
}

const ListTableCard: React.FC<IProps> = ({ data, lang }) => {
  const [cookies] = useCookies();

  const findImageUrl = data?.projectDetails?.find(
    (e) => e.lang === cookies.lang,
  );

  const imageThumbnail = useMemo(() => {
    if (!findImageUrl) {
      if (
        data?.icon_url === null ||
        data?.icon_url === undefined ||
        data?.icon_url === ''
      ) {
        return <NoImage height='200px' />;
      } else {
        return <ThumbnailImage src={data?.icon_url} alt='thumbnail' />;
      }
    } else {
      if (
        findImageUrl?.icon_url === null ||
        findImageUrl?.icon_url === undefined ||
        findImageUrl?.icon_url === ''
      ) {
        return <NoImage height='200px' />;
      }
      return <ThumbnailImage src={findImageUrl?.icon_url} alt='thumbnail' />;
    }
  }, [data, findImageUrl]);
  return (
    <Wrapper>
      <Link to={`story/${data?.project_id}/episode`}>
        <ListTableCardWrapper>
          {imageThumbnail}
          <InforWrapper>
            <p className='title'>{data?.title}</p>
            <div className='statusTag'>
              <p>{data?.project_state}</p>
            </div>
            <p className='lang'>{lang && lang?.code_name}</p>
          </InforWrapper>
        </ListTableCardWrapper>
      </Link>
    </Wrapper>
  );
};

export default ListTableCard;

const Wrapper = styled.div`
  a:hover {
    color: unset;
  }
`;

const ListTableCardWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${theme.colors.gray_8};
  background: #ffffff;
  box-shadow: 0px 8px 16px -2px rgba(27, 36, 44, 0.1);
  overflow: hidden;
`;

const ThumbnailImage = styled.img`
  height: 200px;
  width: 100%;
  object-fit: cover;
  object-position: 100% 30%;
`;

const InforWrapper = styled.div`
  margin: 9px 16px;
  .title {
    margin-bottom: 12px;
    font-size: ${theme.fontSizes.md};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 28px; /* 175% */
    letter-spacing: 0.1px;
  }
  .lang {
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;
